import { NavLink } from "@remix-run/react";
import { forwardRef, type ForwardedRef } from "react";
import { useTranslation } from "react-i18next";
import { fallbackLng } from "~/i18n";

declare type LinkProp = Parameters<typeof NavLink>[0] & { disabled?: boolean }
export const LangLink = forwardRef(function LangLink(props: LinkProp, forwardRef: ForwardedRef<HTMLAnchorElement>) {
	const { i18n: { language } } = useTranslation();
	const { to, disabled, ...rest } = props;
	const onClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => e.preventDefault();
	const ariaProps = disabled ? { "aria-disabled": true, onClick, disabled: "disabled" } : {};
	if (language === fallbackLng) return <NavLink ref={forwardRef} to={to} {...rest} {...ariaProps} />
	if (typeof to === "string") {
		return <NavLink ref={forwardRef} to={`/${language}${to}`} {...rest} {...ariaProps} />
	}
	const { pathname, search, hash } = to;
	return <NavLink ref={forwardRef} to={{ pathname: `/${language}${pathname}`, search, hash }} {...rest} {...ariaProps} />
})